export default __webpack_public_path__ + "static/media/Snd_C8.1d12ca56.mp3";